






















import { Component, Vue } from 'vue-property-decorator'
import store from '../store'
import axios from 'axios'
import singleCard from '@/components/dashboard/singleValue.vue'
import dashChart from '@/components/dashboard/dashChart.vue'
import { getDashboard } from '@/api/dashboard'
@Component({
  name: 'Dashboard',
  components: { singleCard, dashChart }
})
export default class extends Vue {
  weeklyNewVisitors = '-'
  weeklyOrders = '-'
  needingShipment = '-'
  winnings = '-'
  loading = false
  created() {
    this.loading = true
    this.getDashboardData()
    for (let index = 0; index < 12; index++) {
      let rand1 = Math.floor(Math.random() * 100)
      let rand2 = Math.floor(Math.random() * 100)
      if (rand2 < rand1) {
        const tmp = rand1
        rand1 = rand2
        rand2 = tmp
      }
      this.moneyChartSeries[0].data.push(rand1)
      this.moneyChartSeries[1].data.push(rand2)
      this.moneyChartSeries[2].data.push(rand2 - rand1)
    }
  }
  async getDashboardData() {
    const { data } = await getDashboard()
    if (data.successful) {
      this.weeklyNewVisitors = data.weeklyNewVisitors
      this.weeklyOrders = data.weeklyOrders
      this.needingShipment = data.needingShipment
      this.winnings = data.winnings.replace('.', ',') + ' €'
    }
    this.loading = false
  }
  private moneyChartSeries = [
    {
      name: 'Ausgaben',
      data: []
    },
    {
      name: 'Einnahmen',
      data: []
    },
    {
      name: 'Gewinn',
      data: []
    }
  ]

  private moneyChartOptions = {
    chart: {
      type: 'bar',
      height: 250,
      id: 'moneyChart'
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    },
    yaxis: {
      title: {
        text: '€ (Tausende)'
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function(val) {
          return '€ ' + val + ' Tausende'
        }
      }
    }
  }

  private websiteVisitorsSeries = [
    {
      name: 'Besucher',
      data: [2.3, 3.1, 4.0, 10.1, 4.0, 3.6, 3.2, 2.3, 1.4, 0.8, 0.5, 0.2]
    }
  ]
  websiteVisitorsChartOptions = {
    chart: {
      height: 250,
      type: 'bar',
      id: 'visitorChart'
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'top' // top, center, bottom
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function(val) {
        return val
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#304758']
      }
    },

    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      position: 'top',
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      crosshairs: {
        fill: {
          type: 'gradient',
          gradient: {
            colorFrom: '#D8E3F0',
            colorTo: '#BED1E6',
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5
          }
        }
      },
      tooltip: {
        enabled: true
      }
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      title: {
        text: 'Besucher (Tausende)'
      },
      labels: {
        show: true,
        formatter: function(val) {
          return val
        }
      }
    },
    title: {
      text: 'Besucherzahlen der letzten Monate',
      floating: true,
      offsetY: 230,
      align: 'center',
      style: {
        color: '#444'
      }
    }
  }
}
